/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_Activity_Kind_PageInputs */



/**
* | output |
* | --- |
* | "Page" |
*
* @param {Chat_Activity_Kind_PageInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const chat_activity_kind_page = /** @type {((inputs?: Chat_Activity_Kind_PageInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Activity_Kind_PageInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Pagina")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Page")
	return /** @type {LocalizedString} */ ("Page")
});